var _circle, _path, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayPerUse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "#CC0000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 24h-9a4 4 0 0 0 0 8h6a4 4 0 0 1 0 8h-9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 18,
    x2: 32,
    y2: 22
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 42,
    x2: 32,
    y2: 46
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayPerUse);
export default __webpack_public_path__ + "static/media/pay-per-use.fecb11a472209eba497d8a3725b2f5b5.svg";
export { ForwardRef as ReactComponent };